import Cookies from 'js-cookie';

/* eslint-disable no-unused-expressions */
if (window.redirectionSettings) {
    const settings = window.redirectionSettings;
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const inAppBrowsers = {
        facebook: /FBAN|FB_IAB|FBAV/i.test(ua),
        messenger: /\bFB[\w_]+\/(Messenger|JENGA)/i.test(ua),
        instagram: /Instagram/i.test(ua),
        tiktok: /BytedanceWebview|TikTok/i.test(ua),
        snapchat: /Snapchat/i.test(ua),
        twitter: /Twitter/i.test(ua),
        linkedin: /LinkedInApp/i.test(ua),
        pinterest: /Pinterest/i.test(ua),
        line: /\bLine\//i.test(ua),
        wechat: /MicroMessenger/i.test(ua),
    };

    const isInAppBrowser = Object.values(inAppBrowsers).some(Boolean);

    if (settings?.restrict && isInAppBrowser) {
        document.querySelector('meta[http-equiv="refresh"]')?.remove();

        // Expose the detected in-app browser so dr-tracking-codes analytics.js can
        // send the restriction event through sendAnalyticsData. main.js runs
        // synchronously in the <head>, so this is set before analytics.js reads it
        // on DOMContentLoaded.
        settings.inAppBrowser = Object.keys(inAppBrowsers).find(key => inAppBrowsers[key]) || 'unknown';

        document.addEventListener('DOMContentLoaded', () => {
            // Prefer explicit hook if present in content template
            const noticeEl =
                document.querySelector('[data-dr-interstitial-notice]') ||
                document.querySelector('.dr-interstitial-notice') ||
                document.querySelector('.entry-content .wp-block-group .wp-block-group p');

            const notice = settings?.notice;

            if (noticeEl && notice) {
                // If sanitized HTML was provided, render it.
                // Otherwise preserve editor newlines.
                if (/<[a-z][\s\S]*>/i.test(notice)) {
                    noticeEl.innerHTML = notice;
                } else {
                    noticeEl.innerHTML = notice.replace(/\n/g, '<br>');
                }
            }

            const headingEl =
                document.querySelector('[data-dr-interstitial-heading]') ||
                document.querySelector('.dr-interstitial-heading') ||
                document.querySelector('.entry-content h1.wp-block-heading, .entry-content .wp-block-heading');

            const heading = settings?.heading;

            if (headingEl && heading) {
                headingEl.textContent = heading;
            }
        });
    }

    (function initRedirectFallback() {
        if (settings?.restrict && isInAppBrowser) {
            return;
        }

        const metaRefresh = document.querySelector('meta[http-equiv="refresh"][data-dr-interstitial]');
        const defaults = window.drTrackingDefaults;
        let delayMs = 4000;
        let cleanupTimer;
        let targetUrl;

        if (metaRefresh) {
            const content = (metaRefresh.getAttribute('content') || '').trim();
            const match = content.match(/^\s*([\d.]+)\s*;\s*url=(.+)$/i);

            if (match) {
                const delaySec = parseFloat(match[1]);
                const url = match[2].trim();

                console.log('delaySec', delaySec);
                console.log('url', url);

                if (!Number.isNaN(delaySec) && delaySec >= 0 && url) {
                    delayMs = (delaySec * 1000) + 1000;
                    targetUrl = url;
                }
            }
        } else if (defaults && window.location.pathname.includes('/chase-interstitial/')) {
            const rawType = Cookies.get('disneyrewards-cardmember-type') || 'classic';
            const cardType = ['classic', 'premier', 'inspire'].includes(rawType) ? rawType : 'classic';
            const path = window.location.pathname.replace(/\/?(redirect|notice)\/[^/]*\/?$/, '');
            const slugMatch = window.location.pathname.match(/\/(?:redirect|notice)\/([^/]+)/);
            const currentSlug = slugMatch ? slugMatch[1] : '';
            const slugParts = currentSlug.split('-');

            // The spid could be invalid, so using the default value.
            const spid = slugParts[0] ? defaults.spid[cardType] : '';
            const cell = slugParts[1] || defaults.cell[cardType] || defaults.cellOrganic || defaults.cell.classic || '';

            if (spid && cell) {
                const fallbackUrl = `${path}/redirect/${spid}-${cell}/`;
                if (fallbackUrl !== window.location.pathname) {
                    targetUrl = fallbackUrl;
                }
            }
        }

        if (!targetUrl) {
            targetUrl = '/compare-credit-cards/';
        }

        const fallbackTimer = setTimeout(() => {
            // eslint-disable-next-line no-console
            console.info('Fallback redirect to:', targetUrl);
            window.location.href = targetUrl;
        }, delayMs);

        function cancelFallback() {
            clearTimeout(fallbackTimer);
        }

        function cleanup() {
            clearTimeout(fallbackTimer);
            clearTimeout(cleanupTimer);
            window.removeEventListener('beforeunload', cancelFallback);
            window.removeEventListener('pagehide', cancelFallback);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        }

        function onVisibilityChange() {
            if (document.visibilityState === 'hidden') {
                cancelFallback();
                cleanup();
            }
        }

        window.addEventListener('beforeunload', cancelFallback);
        window.addEventListener('pagehide', cancelFallback); 
        document.addEventListener('visibilitychange', onVisibilityChange);

        cleanupTimer = setTimeout(cleanup, delayMs + 1000);
    })();
}
